<div class="search__input__container">
  <span class="p-input-icon-left mt-2">
    <i class="pi pi-search"></i>
    <input
      type="text"
      pInputText
      [placeholder]="'GLOBAL.SEARCH_PLACEHOLDER' | translate"
      [(ngModel)]="search"
      class="p-inputtext"
      (keyup)="trigger()"
      [disabled]="disabled()"
    />
  </span>
</div>
